module.exports = "<div class=\"row\">\r\n  <div class=\"col-md-4\" ng-repeat=\"stat in admin.stats\">\r\n    <h3>\r\n      <span class=\"label\" ng-class=\"{'label-info': stat._id.lot == 'Main', 'label-warning':  stat._id.lot == 'West'}\">{{stat._id.lot}}</span>\r\n      <span class=\"label\" ng-class=\"{'label-success': stat._id.status == 'Accepted', 'label-info':  stat._id.status == 'Pending', 'label-warning':  stat._id.status == 'Wait List', 'label-danger':  stat._id.status == 'Rejected'}\">{{stat._id.status}}</span>\r\n      : {{stat.count}}\r\n    </h3>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/home.html
// module id = 39
// module chunks = 0